document.addEventListener("DOMContentLoaded", (event) => {

    const carousel = document.querySelectorAll('.carousel-2');

    if (carousel) {
        carousel.forEach(carousel_block => {

            const list = carousel_block.querySelector('.carousel-2__list');
            const next = carousel_block.querySelector('.carousel-2__next-btn') || null;
            const prev = carousel_block.querySelector('.carousel-2__prev-btn') || null;
            const nav_container = carousel_block.querySelector('.carousel-2__nav') || null;

            const swiper = new Swiper(list, {
                loop: true,
                loopPreventsSliding: true,
                autoplay: {
                    delay: 7500,
                    disableOnInteraction: false,
                },
                navigation: {
                    nextEl: next,
                    prevEl: prev,
                },
                on: {
                    init: function () { toggleCustomNavigation(this, nav_container); },
                    resize: function () { toggleCustomNavigation(this, nav_container); },
                },
                slidesPerView: 1.15,
                spaceBetween: 20,
                autoHeight: true,
                breakpoints: {
                    440: {
                        slidesPerView: 2,
                        spaceBetween: 16,
                    },
                    500: {
                        slidesPerView: 2.2,
                        spaceBetween: 16,
                    },
                    748: {
                        slidesPerView: 3.5,
                        spaceBetween: 16,
                    },
                    991: {
                        slidesPerView: 4.2,
                        spaceBetween: 16,
                    },
                    1200: {
                        slidesPerView: 5,
                        spaceBetween: 16,
                    }
                }
            });

        });

        function toggleCustomNavigation(swiperInstance, nav_container) {
            if (swiperInstance.params.navigation && nav_container) {
                if (swiperInstance.slides.length <= swiperInstance.params.slidesPerView) {
                    nav_container.style.display = 'none';
                } else {
                    nav_container.style.display = 'flex';
                }
            }
        }
    }

});
